import {
  COMPANY_PROFILE_FETCH_REQUEST,
  COMPANY_PROFILE_FETCH_SUCCESS,
  COMPANY_PROFILE_FETCH_FAILURE,
  COMPANY_PROFILE_CLEAR,
  COMPANY_PROFILE_UPDATE_REQUEST,
  COMPANY_PROFILE_UPDATE_SUCCESS,
  COMPANY_PROFILE_UPDATE_FAILURE,
  COMPANY_PROFILE_INDUSTRIES_SUCCESS,
  COMPANY_PROFILE_JO_FETCH_REQUEST,
  COMPANY_PROFILE_JO_FETCH_SUCCESS,
  COMPANY_PROFILE_JO_FETCH_FAILURE,
  COMPANY_PROFILE_JO_ADD_REQUEST,
  COMPANY_PROFILE_JO_ADD_SUCCESS,
  COMPANY_PROFILE_JO_ADD_FAILURE,
  COMPANY_PROFILE_JO_DELETE_REQUEST,
  COMPANY_PROFILE_JO_DELETE_SUCCESS,
  COMPANY_PROFILE_JO_DELETE_FAILURE,
  COMPANY_PROFILE_JD_LIST_SUCCESS,
} from '../actions/actionTypes';
import { CompanyProfileAction } from '../actions/companyProfileActions';

interface CompanyProfileState {
  company: any | null;
  raw: any | null;
  industries: { id: string; name: string }[];
  loading: boolean;
  error: string | null;
  updateLoading: boolean;
  updateError: string | null;
  jobOpenings: any[];
  jobOpeningsLoading: boolean;
  jobOpeningsError: string | null;
  joAddLoading: boolean;
  joDeleteLoading: boolean;
  jobDescriptions: any[];
}

const initialState: CompanyProfileState = {
  company: null,
  raw: null,
  industries: [],
  loading: false,
  error: null,
  updateLoading: false,
  updateError: null,
  jobOpenings: [],
  jobOpeningsLoading: false,
  jobOpeningsError: null,
  joAddLoading: false,
  joDeleteLoading: false,
  jobDescriptions: [],
};

export default function companyProfileReducer(
  state = initialState,
  action: CompanyProfileAction,
): CompanyProfileState {
  switch (action.type) {
    case COMPANY_PROFILE_FETCH_REQUEST:
      return { ...state, loading: true, error: null };
    case COMPANY_PROFILE_FETCH_SUCCESS:
      return { ...state, loading: false, company: action.payload.company, raw: action.payload.raw };
    case COMPANY_PROFILE_FETCH_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case COMPANY_PROFILE_CLEAR:
      return { ...initialState, industries: state.industries, jobDescriptions: state.jobDescriptions };
    case COMPANY_PROFILE_UPDATE_REQUEST:
      return { ...state, updateLoading: true, updateError: null };
    case COMPANY_PROFILE_UPDATE_SUCCESS:
      return { ...state, updateLoading: false, company: action.payload.company, raw: action.payload.raw };
    case COMPANY_PROFILE_UPDATE_FAILURE:
      return { ...state, updateLoading: false, updateError: action.payload };
    case COMPANY_PROFILE_INDUSTRIES_SUCCESS:
      return { ...state, industries: action.payload };

    case COMPANY_PROFILE_JO_FETCH_REQUEST:
      return { ...state, jobOpeningsLoading: true, jobOpeningsError: null };
    case COMPANY_PROFILE_JO_FETCH_SUCCESS:
      return { ...state, jobOpeningsLoading: false, jobOpenings: action.payload };
    case COMPANY_PROFILE_JO_FETCH_FAILURE:
      return { ...state, jobOpeningsLoading: false, jobOpeningsError: action.payload };

    case COMPANY_PROFILE_JO_ADD_REQUEST:
      return { ...state, joAddLoading: true };
    case COMPANY_PROFILE_JO_ADD_SUCCESS:
      return { ...state, joAddLoading: false };
    case COMPANY_PROFILE_JO_ADD_FAILURE:
      return { ...state, joAddLoading: false };

    case COMPANY_PROFILE_JO_DELETE_REQUEST:
      return { ...state, joDeleteLoading: true };
    case COMPANY_PROFILE_JO_DELETE_SUCCESS:
      return { ...state, joDeleteLoading: false, jobOpenings: state.jobOpenings.filter((jo) => jo.id !== action.payload) };
    case COMPANY_PROFILE_JO_DELETE_FAILURE:
      return { ...state, joDeleteLoading: false };

    case COMPANY_PROFILE_JD_LIST_SUCCESS:
      return { ...state, jobDescriptions: action.payload };

    default:
      return state;
  }
}
